<h5>Email Settings</h5>
<form [formGroup]="emailConfigForm" *ngIf="emailConfigForm">
  <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
    <div fxFlex="32%">
      <mat-checkbox formControlName="isMailBoxMonitored">Is Mail Box Monitored</mat-checkbox>
    </div>
    <div fxFlex="32%">
      <mat-checkbox formControlName="identifyClientsInUnsubscribeLink">
        Identify Clients in Unsubscribe Link
      </mat-checkbox>
    </div>
    <div fxFlex="32%">
      <mat-checkbox formControlName="hideEmailTrackingCode">
        Hide Email Tracking Code
      </mat-checkbox>
    </div>
    <div fxFlex="32%">
      <mat-checkbox formControlName="weeklyEmailEnabled">Weekly Mail Enabled</mat-checkbox>
    </div>
    <div fxFlex="64%">
      <mat-checkbox formControlName="excludeUnsubscribeLinkInEmail" [disabled]="!isSurvaleAdmin">
        Hide Unsubscribe Link in emails sent <b>IMPORTANT: Use only for Employee Campaigns</b>
      </mat-checkbox>
    </div>
  </div>

  <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Email Provider</mat-label>
        <mat-select formControlName="emailProvider">
          <mat-option value="Sendgrid">Sendgrid</mat-option>
          <mat-option value="SES">Amazon SES</mat-option>
          <mat-option value="SES_MAILER">Amazon SES using Node Mailer</mat-option>
          <mat-option value="SMTP_MAILER">SMTP using Node Mailer</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="row wrap" class="settings-row test-email-row" fxLayoutGap="10px">
    <div fxFlex="49%">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Send Test Email To</mat-label>
        <input matInput type="email" placeholder="you@example.com" #mainTestEmailInput>
        <mat-hint>Sends a test email using the Email Provider configured above.</mat-hint>
      </mat-form-field>
    </div>
    <div fxFlex="32%" class="test-email-btn">
      <button mat-raised-button type="button" [disabled]="testingMainProvider"
        (click)="testMainEmailProvider(mainTestEmailInput.value)">
        {{testingMainProvider ? 'Sending...' : 'Send Test Email'}}
      </button>
    </div>
  </div>

  <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px" *ngIf="emailConfigForm.get('emailProvider').value === 'SMTP_MAILER'">
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>SMTP Host</mat-label>
        <input matInput formControlName="smtpHost">
      </mat-form-field>
    </div>
    <div fxFlex="15%">
      <mat-form-field appearance="outline">
        <mat-label>SMTP Port</mat-label>
        <input matInput type="number" formControlName="smtpPort">
      </mat-form-field>
    </div>
    <div fxFlex="15%" style="padding: 4% 2%;">
      <mat-checkbox formControlName="smtpSecure">Secure (TLS)</mat-checkbox>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>SMTP Auth User</mat-label>
        <input matInput formControlName="smtpAuthUser">
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>SMTP Auth Password</mat-label>
        <input matInput [type]="hideSmtpPassword ? 'password' : 'text'" formControlName="smtpAuthPass">
        <button mat-icon-button matSuffix type="button" (click)="hideSmtpPassword = !hideSmtpPassword">
          <mat-icon>{{hideSmtpPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>TLS Server Name (SNI)</mat-label>
        <input matInput formControlName="smtpTlsServername">
        <mat-hint>Defaults to SMTP Host if left blank</mat-hint>
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>TLS Min Version</mat-label>
        <input matInput placeholder="e.g. TLSv1.2" formControlName="smtpTlsMinVersion" [matAutocomplete]="smtpTlsMinVersionAuto">
        <mat-autocomplete #smtpTlsMinVersionAuto="matAutocomplete">
          <mat-option *ngFor="let opt of tlsMinVersionOptions" [value]="opt.value">{{opt.label}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>TLS Ciphers</mat-label>
        <input matInput formControlName="smtpTlsCiphers">
      </mat-form-field>
    </div>
    <div fxFlex="32%" style="padding: 4% 2%;">
      <mat-checkbox formControlName="smtpTlsRejectUnauthorized">Reject Unauthorized TLS</mat-checkbox>
    </div>
  </div>

  <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Reply To Email</mat-label>
        <input matInput placeholder="" formControlName="replyToEmail">
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Reply To Name</mat-label>
        <input matInput placeholder="Name as it appears in Email From" formControlName="replyToName">
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Header: header_from</mat-label>
        <input matInput placeholder="talent.survale.com" formControlName="header_from">
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Header: smtp_mailfrom</mat-label>
        <input matInput placeholder="talent.survale.com" formControlName="smtp_mailfrom">
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>One click Unsubscribe Url</mat-label>
        <input matInput placeholder="talent.survale.com" formControlName="unsubscribeUrl">
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>System Generated Reply To Email</mat-label>
        <input matInput placeholder="" formControlName="systemReplyToEmail">
        <mat-hint>All the emails that are sent by the system (e.g. Dashboard Screenshot emails)</mat-hint>
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>System Generated Reply To Name</mat-label>
        <input matInput placeholder="Name as it appears in Email From" formControlName="systemReplyToName">
        <mat-hint>All the emails that are sent by the system (e.g. Dashboard Screenshot emails)</mat-hint>
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
    <div fxFlex="49%">
      <mat-form-field appearance="outline">
        <mat-label>Email Footer HTML</mat-label>
        <textarea matInput placeholder="" rows="6" formControlName="emailFooterText"></textarea>
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
    <div fxFlex="49%">
      <mat-form-field appearance="outline">
        <mat-label>Unsubscribe Prefix</mat-label>
        <input matInput placeholder="" formControlName="unsubscribePrefix">
        <label matSuffix>Click here</label>
      </mat-form-field>
    </div>
    <div fxFlex="98%">
      <label>Default Email Footer HTML </label>
      <pre>{{defaultEmailFooterText}}</pre>
    </div>
  </div>

  <div class="internal-email-provider-section">
    <h5>Client Corporate Email Domains</h5>
    <p class="hint-text">
      Domains of the client's corporate email addresses. Used to identify whether an email is a personal or
      corporate email — including routing to the Internal Email Provider below when enabled.
    </p>

    <div fxLayout="row wrap" fxLayoutGap="10px">
      <div fxFlex="32%">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Client Corporate Email Domain</mat-label>
          <input matInput placeholder="" formControlName="clientEmailDomain">
          <mat-add-on-button matSuffix>
            <button mat-icon-button (click)="addToCorporateEmailDomain()"><mat-icon>add</mat-icon></button>
          </mat-add-on-button>
          <mat-hint>This is the domain of the client's email address. This is used to identify whether the email is a
            personal email or a corporate email.</mat-hint>
        </mat-form-field>
      </div>
      <div fxFlex="64%">
        <div *ngFor="let domain of settings?.corporateEmailDomains" class="domain-item">
          <span>{{domain}}</span>
          <button mat-icon-button (click)="removeFromCorporateEmailDomain(domain)"><mat-icon>delete</mat-icon></button>
        </div>
      </div>
    </div>
  </div>

  <div class="internal-email-provider-section">
    <h5>Internal Email Provider</h5>
    <p class="hint-text">
      Used for emailing employees at internal/corporate email addresses. The system routes to this provider
      when the recipient's email domain matches one of the Client Corporate Email Domains above.
    </p>

    <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
      <div fxFlex="98%">
        <mat-checkbox formControlName="internalEmailProviderEnabled">Enabled</mat-checkbox>
      </div>
    </div>

    <ng-container *ngIf="emailConfigForm.get('internalEmailProviderEnabled').value">
      <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
        <div fxFlex="32%">
          <mat-form-field appearance="outline">
            <mat-label>SMTP Host</mat-label>
            <input matInput formControlName="internalSmtpHost">
          </mat-form-field>
        </div>
        <div fxFlex="15%">
          <mat-form-field appearance="outline">
            <mat-label>SMTP Port</mat-label>
            <input matInput type="number" formControlName="internalSmtpPort">
          </mat-form-field>
        </div>
        <div fxFlex="15%" style="padding: 4% 2%;">
          <mat-checkbox formControlName="internalSmtpSecure">Secure (TLS)</mat-checkbox>
        </div>
        <div fxFlex="32%">
          <mat-form-field appearance="outline">
            <mat-label>SMTP Auth User</mat-label>
            <input matInput formControlName="internalSmtpAuthUser">
          </mat-form-field>
        </div>
        <div fxFlex="32%">
          <mat-form-field appearance="outline">
            <mat-label>SMTP Auth Password</mat-label>
            <input matInput [type]="hideInternalSmtpPassword ? 'password' : 'text'" formControlName="internalSmtpAuthPass">
            <button mat-icon-button matSuffix type="button" (click)="hideInternalSmtpPassword = !hideInternalSmtpPassword">
              <mat-icon>{{hideInternalSmtpPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div fxFlex="32%">
          <mat-form-field appearance="outline">
            <mat-label>TLS Server Name (SNI)</mat-label>
            <input matInput formControlName="internalSmtpTlsServername">
            <mat-hint>Defaults to SMTP Host if left blank</mat-hint>
          </mat-form-field>
        </div>
        <div fxFlex="32%">
          <mat-form-field appearance="outline">
            <mat-label>TLS Min Version</mat-label>
            <input matInput placeholder="e.g. TLSv1.2" formControlName="internalSmtpTlsMinVersion"
              [matAutocomplete]="internalSmtpTlsMinVersionAuto">
            <mat-autocomplete #internalSmtpTlsMinVersionAuto="matAutocomplete">
              <mat-option *ngFor="let opt of tlsMinVersionOptions" [value]="opt.value">{{opt.label}}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div fxFlex="32%">
          <mat-form-field appearance="outline">
            <mat-label>TLS Ciphers</mat-label>
            <input matInput formControlName="internalSmtpTlsCiphers">
          </mat-form-field>
        </div>
        <div fxFlex="32%" style="padding: 4% 2%;">
          <mat-checkbox formControlName="internalSmtpTlsRejectUnauthorized">Reject Unauthorized TLS</mat-checkbox>
        </div>
      </div>

      <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
        <div fxFlex="32%">
          <mat-form-field appearance="outline">
            <mat-label>From Email</mat-label>
            <input matInput formControlName="internalFromEmail">
          </mat-form-field>
        </div>
        <div fxFlex="32%">
          <mat-form-field appearance="outline">
            <mat-label>From Name</mat-label>
            <input matInput placeholder="Name as it appears in Email From" formControlName="internalFromName">
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap" class="settings-row test-email-row" fxLayoutGap="10px">
        <div fxFlex="49%">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Send Test Email To</mat-label>
            <input matInput type="email" placeholder="you@example.com" #internalTestEmailInput>
            <mat-hint>Sends a test email using the Internal Email Provider configured above.</mat-hint>
          </mat-form-field>
        </div>
        <div fxFlex="32%" class="test-email-btn">
          <button mat-raised-button type="button" [disabled]="testingInternalProvider"
            (click)="testInternalEmailProvider(internalTestEmailInput.value)">
            {{testingInternalProvider ? 'Sending...' : 'Send Test Email'}}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</form>
